import { StyleType } from "@iventis/domain-model/model/styleType";

export const WHAT3WORDS_ATTRIBUTE_NAME = "What3Words";

export const WHAT3WORDS_REFETCH_RETRY_MS = 1000;

export const WHAT3WORDS_MAX_RETRY_ATTEMPTS = 3;

export const allowedStyleTypesForWhat3Words = [StyleType.Point, StyleType.Icon, StyleType.Model];
